import { Avatar, Box, Card, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import type { KnownNotificationResource } from '../../../api/notifications'
import { mediaSourceUrl } from './utils'
import { IconGrowthTools } from '../../../icons/IconGrowthTools'
import { NotificationEntityHeader } from './NotificationEntityHeader'
import { createNotificationNavHandlers, getActorPathKey, getGrowthToolSlug } from './notificationNav'
import { ActorNameSpan, ProjectNameQuoted } from './notificationTypography'
import { notificationBodyWrapSx } from './notificationTextClamp'

type Props = {
  notification: Extract<KnownNotificationResource, { type: 'growth_tool.restriction.removed' }>
}

export function GrowthToolRestrictionRemovedNotificationCard({ notification }: Props) {
  const navigate = useNavigate()
  const { onGrowthToolClick, onUserClick } = createNotificationNavHandlers(navigate)
  const payload = notification.payload
  const growthTool = payload.growth_tool
  const actor = payload.actor
  const growthToolTitle =
    typeof growthTool?.title === 'string' && growthTool.title.trim().length > 0
      ? growthTool.title
      : 'инструмент роста'
  const actorName =
    typeof actor?.fullname === 'string' && actor.fullname.trim().length > 0 ? actor.fullname : 'Пользователь'
  const growthToolAvatarSrc = mediaSourceUrl(growthTool?.image_url) ?? undefined
  const growthToolSlug = getGrowthToolSlug(growthTool)
  const actorPathKey = getActorPathKey(actor, notification.actor_user_id)

  return (
    <Card variant="primaryAdaptiveCard" sx={{ p: 2 }}>
      <Stack direction="column" minWidth={0} flex={1} gap={1.25}>
        <Box
          onClick={(e) => onGrowthToolClick(e, growthToolSlug)}
          sx={{ cursor: growthToolSlug ? 'pointer' : 'default', alignSelf: 'stretch' }}
        >
          <NotificationEntityHeader
            title={growthToolTitle}
            avatarSrc={growthToolAvatarSrc}
            fallbackIcon={<IconGrowthTools fontSize="small" sx={{ color: 'inherit' }} />}
            subtitle="Ограничение снято"
          />
        </Box>

        <Stack direction="row" gap={1.5} alignItems="center" minWidth={0}>
          <Box
            onClick={actorPathKey ? (e) => onUserClick(e, actorPathKey) : undefined}
            sx={{ cursor: actorPathKey ? 'pointer' : 'default', flexShrink: 0 }}
          >
            <Avatar
              src={mediaSourceUrl(actor?.avatar_url) ?? undefined}
              alt={actorName}
              sx={{ width: 34, height: 34 }}
            />
          </Box>
          <Stack minWidth={0}>
            <Typography variant="black-14-normal" sx={notificationBodyWrapSx}>
              <ActorNameSpan pathKey={actorPathKey} onUserClick={onUserClick}>
                {actorName}
              </ActorNameSpan>
              {' снял(а) ограничения доступа к инструменту роста '}
              <ProjectNameQuoted name={growthToolTitle} pathKey={growthToolSlug} onNameClick={onGrowthToolClick} />
            </Typography>
          </Stack>
        </Stack>

        <Typography variant="black-12-light" noWrap sx={{ opacity: 0.8 }}>
          {notification.read_at ? 'Прочитано' : 'Непрочитано'} • {new Date(notification.created_at).toLocaleString()}
        </Typography>
      </Stack>
    </Card>
  )
}
